import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';

import * as CONSTANTS from './constants';
import * as CONFIG from './config';
import * as UTILS from './utils/utilFunctions';
import { syncStoredToken, readToken, clearStoredToken } from './utils/tokenStorage';
import parseTokenToState from './utils/parseTokenToState';

class PageContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { verified: false };
    this.lastLocation = '';
    this.props.history.listen(location => {
      if (this.lastLocation !== location.pathname) {
        this.lastLocation = location.pathname;
        this.checkAuthentication(location.pathname);
      }
    });
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  componentWillMount() {
    this.setState({ verified: false });
    syncStoredToken(() => this.checkAuthentication(this.props.history.location.pathname));
  }

  checkAuthentication(currentPage) {
    this.props.liftUpStateToApp('currentPage', currentPage);

    // check authentication only if page requires authentication
    // CASE page which require login
    if (!CONFIG.pagesWithoutLogin.includes(currentPage) || currentPage === '/') {
      // CASE token available => validate token
      const tokenFromLocalStorage = readToken();
      if (tokenFromLocalStorage) {
        this.verifyTokenAPIcall(tokenFromLocalStorage);
      }
      // CASE no token available => redirect to loginPage
      else if (currentPage !== '/') {
        this.props.history.push('/');
      }

      // CASE login page without token => show loginPage
      else if (currentPage === '/') {
        this.setState({ verified: true });
      }
    }
    // CASE page which doesn't require login
    else {
      this.setState({ verified: true });
    }
  }

  verifyTokenAPIcall(token) {
    this.props.liftUpStateToApp('showLoadingIndicatorLoggedIn', true);
    const url = CONSTANTS.verifyTokenURL;
    const pagesWithoutReleaseNotes = CONFIG.pagesWithoutLogin.concat(['/register', '/registerTan']);
    const requestBody = {
      requestReleaseNote: !pagesWithoutReleaseNotes.includes(this.props.history.location.pathname),
      requestSerialMailCount: ['/markLists'].includes(this.props.history.location.pathname)
    };
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(requestBody),
      headers: { 'x-auth': token }
    })
      .done(responseBody => {
        this.props.liftUpStateToApp(parseTokenToState(token, responseBody.user, responseBody.serialMailCount));
        this.props.liftUpStateToApp('showLoadingIndicatorLoggedIn', false);
        this.props.liftUpStateToApp('notificationCount', responseBody.notificationCount);
        this.props.liftUpStateToApp('releaseNote', responseBody.releaseNote);

        // check if user status allows to see specific pages
        const currentPage = this.props.history.location.pathname;
        const userStatus = responseBody.user.status;

        if (
          ([
            '/notifications',
            '/reminders/companies',
            '/reminders/candidates',
            '/search',
            '/results',
            '/markLists',
            '/offers',
            '/applicantUser',
            '/applicantUser/details',
            '/counterParts',
            '/companies',
            '/projects',
            '/intranet',
            '/candidates',
            '/incomingCandidates',
            '/incomingMatchingProfiles',
            '/matchingProfiles'
          ].includes(currentPage) &&
            userStatus === 'active') ||
          (['/register'].includes(currentPage) && userStatus === 'initialLogin') ||
          (['/registerTan'].includes(currentPage) && userStatus === 'passwordSet') ||
          (['/settings'].includes(currentPage) && userStatus === 'active')
          // userRole === 'admin'
        ) {
          // if yes
          this.setState({ verified: true });

          // if no
          // redirect to correct page
        } else if (userStatus === 'initialLogin' && currentPage !== '/register') this.props.history.replace('/register');
        else if (userStatus === 'passwordSet' && currentPage !== '/registerTan') this.props.history.replace('/registerTan');
        else if (userStatus === 'active' && !['/search', '/results', '/settings'].includes(currentPage)) {
          this.props.history.replace('/search');
        } else {
          clearStoredToken();
          this.props.history.replace('/');
        }
      })
      .fail(err => {
        this.props.liftUpStateToApp('showLoadingIndicatorLoggedIn', false);
        // login with existing token which is invalid (e.g. belongs to a different user)
        if (this.props.history.location.pathname === '/') {
          this.setState({ verified: true });
        } else {
          this.errorHandling(err, url, this.props.liftUpStateToApp);
        }
      });
  }

  render() {
    const showPage = CONFIG.pagesWithoutLogin.includes(this.props.history.location.pathname) || this.state.verified;
    return showPage ? this.props.children : '';
  }
}

PageContainer.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  liftUpStateToApp: PropTypes.func.isRequired
};

export default withRouter(PageContainer);
